import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';

import { useFormik } from 'formik';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { getMetaPages, patchMetaPages, postMetaPages } from 'Services/Meta/MetaPages';

const AddMetaPages = () => {
    const { state } = useLocation();
    const { type } = useParams();

    const navegate = useNavigate();
    // const handleEditorChange = (value) => {
    //   setContent(value);
    // };

    const client = useQueryClient()
    const { data, refetch } = useQuery(["metapagesbyId", state], () => getMetaPages({ page_id: state }), { enabled: Boolean(state) })

    const Data = data?.data?.data

    const { mutate: AddMetaPages } = useMutation(postMetaPages, {
        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.message)
                client.refetchQueries("metapages")
                navegate("/meta")
            }
            else {
                toast.warn(res?.data?.message)
            }
        }
    })

    const { mutate: UpdateMetaPages } = useMutation(patchMetaPages, {
        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.message)
                client.refetchQueries("metapages")
                navegate("/meta")
            }
            else {
                toast.warn(res?.data?.message)
            }
        }
    })



    console.log(data);

    const formik = useFormik({
        initialValues: {
            name: Data?.name || "",
            path: Data?.path || "",
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            const reqbody = new FormData();
            reqbody.append("store", localStorage.getItem("store_id"));
            reqbody.append("name", values.name);
            // reqbody.append("path", values.path);
            type !== "update"
                ? reqbody.append("path", values.path)
                : formik.values.path && reqbody.append("path", values.path);
            type === "update" && reqbody.append("page_id", state);
            type === "add"
                ? AddMetaPages(reqbody)
                : UpdateMetaPages(reqbody)
        },
    });
    return (
        <div className="flex flex-col justify-center gap-5 py-4 text-black lg:flex-row">
            <div className="flex flex-col justify-center w-full lg:w-3/5">
                <div className="mt-5 bg-white shadow-lg">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-2 border-gray-300 rounded-md ">
                            <div className="flex flex-col gap-5">
                                <div className="w-full pl-3 ">
                                    <div>
                                        <p className="p-1 text-sm font-semibold">Meta</p>
                                        <input
                                            id="name"
                                            placeholder="Enter page name"
                                            value={formik.values.name}
                                            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                                            onChange={formik.handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="w-full pl-3">
                                    <div>
                                        <p className="p-1 text-sm font-semibold">Page Path</p>
                                        <input
                                            id="path"
                                            placeholder="Enter path"
                                            value={formik.values.path}
                                            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                                            onChange={(e) => {

                                                formik.setFieldValue("path", e.target.value.replace(/ /g, "_"));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="w-full pl-3 ">
                                    <Button type="submit" variant="contained">
                                        {state ? "Update" : "Add"}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddMetaPages